"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeveloperSettingsContext = void 0;
const react_1 = require("react");
exports.DeveloperSettingsContext = (0, react_1.createContext)({});
